import { observer } from "mobx-react-lite";
import { BasePage } from "../../common/BasePage";
import { useContext, useState } from "react";
import { storeContext } from "../../../store/root-store";
import { ListOfQuotes } from "./ListOfQuotes";

export const SearchPage = observer(() => {
  const { quotesGl } = useContext(storeContext);
  const [searchVal, setSearchVal] = useState<string>("");
  const onSearchChange = (e: any) => {
    setSearchVal(e.target.value);
  };
  const onSearch = async (e: any, searchV: string) => {
    e.preventDefault();
    quotesGl.search(searchV);
  };
  return (
    <BasePage>
      <form
        action=""
        className="d-flex"
        onSubmit={(e) => {
          onSearch(e, searchVal);
        }}
      >
        <input
          type="text"
          className="form-control"
          placeholder="Введите цитату"
          onChange={onSearchChange}
          value={searchVal}
        />
        <button type="submit" className="btn btn-primary mr-2">
          Найти
        </button>
      </form>
      <ListOfQuotes listOfQuotes={quotesGl.data}></ListOfQuotes>
    </BasePage>
  );
});
